var pe1 = "/static/3038632974d60048.png";

export { pe1 as default };
//# sourceMappingURL=pe_1.png.js.map
